module.exports = __webpack_public_path__ + "static/media/rating.d45650f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rating.png
// module id = 212
// module chunks = 0